import React from "react";
import SelectComponent from "./SelectComponent";
import DatePickerComponent from "./DatePickerComponent";
import TimePickerComponent from "./TimePickerComponent";
import InputComponent from "./InputComponent";
import FileAttachment from "./FileAttachment";
import MemoArea from "./MemoArea";
import DeleteIcon from "../../assets/images/icons/deleteIcon";
import dangerIconRed from "../../assets/images/icons/dangerIconRed.svg";

const options = [
  {
    id: "ajldjajawd",

    value: "option1",
    label: "Option 1",
    endAdornment: "Vendor",

    children: [
      {
        id: "ajldjajawd",
        value: "option1-1",
        label: "Option 1.1",
        endAdornment: "Vendor",
      },
      {
        value: "option1-2",
        label: "Option 1.2",
        endAdornment: "Info 1.2 Info 1.2 Info 1.2",
        children: [
          {
            startAdornment: "%",
            value: "option1-11",
            label: "Option 1.1",
            endAdornment: "Info 1.1",
          },
          {
            value: "option1-22",
            label: "Option 1.2",
            endAdornment: "Info 1.2",
          },
        ],
      },
    ],
  },
  {
    value: "option3",
    label: "Option 3",
    endAdornment: "Customer",
  },
  {
    value: "option4",
    label: "Option 4",
    endAdornment: "Vendor",
  },
  {
    value: "option5",
    label: "Option 5",
    endAdornment: "Customer",
  },
  {
    value: "option6",
    label: "Option 6",
    endAdornment: "Vendor",
  },
];

const CustomFields = ({ field, onChange, value, handleLinkClick, isTable, index, deleteRow, voucher, fieldError }) => {
  const renderField = (field, onChange, value, fieldError) => {
    switch (field.type_name ?? field.type) {
      case "dropdown":
        return (
          <div className={`w-full`}>
            {!isTable && (
              <label className="block text-sm font-medium mb-1" htmlFor={field.id}>
                {field.label}
              </label>
            )}
            <SelectComponent
              placeholder={field.placeholder}
              id={field.id}
              // options={options}
              options={field.option_type === "API" ? null : field?.options?.options}
              apiMetaData={field.option_type === "API" ? field.metadata : null}
              value={value}
              name={field.name}
              onChange={onChange}
              isTagList={Boolean(field.isTagList)}
              //   className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
              required={field.required}
              style={{ width: "100%" }}
              // selectedOptions={selected}
              multiSelect={Boolean(field.isMultiSelect)}
              toggleButtons={Boolean(field.isToggleButtons)}
              personList={Boolean(field.isPersonList)}
              showSearch={Boolean(field.isSearchable)}
              // addButton={field.isAddButton}
              // addButtonLabel={field.addButtonLabel}
              // addButtonAction={()=>handleLinkClick(field.addButtonAction)}
              addButton={true}
              addButtonLabel={"Add New Vendor"}
              addButtonAction={() => handleLinkClick("addVendor")}
              // startAdornment={<span>🌟</span>}
              endAdornment={
                <span>
                  <i class="bi bi-chevron-down"></i>
                </span>
              }
              size={isTable && "small"}
              // maxVisibleSelections = {4}
              // // listComponent={ListComponent}
              voucher={voucher}
              error={fieldError && field.isCompulsory}
            />
            {fieldError && field.isCompulsory && !value?.length && (
              <span
                className="flex gap-1 items-center text-xs text-gray-500 ms-1 text-[#BF2315] text-[10px]"
                role="alert"
                aria-live="assertive"
              >
                <img src={dangerIconRed} className="h-[10px] w-[10px]" alt="Error icon" />
                Please Select {field?.label}
              </span>
            )}

            {field.linkInfo && (
              <button
                className="border-none bg-none text-blue-500"
                onClick={() => handleLinkClick(field.linkInfo?.key)}
              >
                {field.linkInfo?.label}
              </button>
            )}
          </div>
        );
      //   case "text":
      case "date":
        return (
          <DatePickerComponent
            id={field.id}
            name={field.id}
            value={value} // Ensure the form data value is passed
            onChange={(date) => onChange({ target: { name: field.id, value: date } })} // Handle change
            placeholder={field.placeholder}
            label={field.label}
            required={field.required}
            format
            // error={value ? "" : "Please select a date"} // Display error if no date is selected
            mandatory={field.isCompulsory}
            error={fieldError}
            helperText={"Please select a date"}
          />
        );

      case "time":
        return (
          <TimePickerComponent
            id={field.id}
            name={field.id}
            value={value} // Ensure the form data value is passed
            onChange={(date) => onChange({ target: { name: field.id, value: date } })} // Handle change
            placeholder={field.placeholder}
            label={field.label}
            required={field.required}
            format
            // error={value ? "" : "Please select a date"} // Display error if no date is selected
            error={fieldError}
            mandatory={field.isCompulsory}
            helperText={"Please select a time"}
          />
        );

      case "text":
        return (
          // <div className={`w-full`}>
          //   <label className="block text-sm font-medium mb-1" htmlFor={field.id}>
          //     {field.label}
          //   </label>
          //   <Input type={field.type} placeholder={field.placeholder} value={field.value} onChange={field.onChange} />
          // </div>
          <div className="w-full mx-auto">
            <InputComponent
              type={field.type}
              value={value || ""}
              onChange={onChange}
              onKeyDown={onChange}
              label={!isTable && field.label}
              placeholder={field.placeholder}
              helperText={!isTable && "Please Enter the Value"}
              error={fieldError}
              id={field.id}
              name={field.id}
              className="custom-input-class"
              mandatory={field.isCompulsory}
              height={isTable && "30px"}
            />
          </div>
        );
      case "decimal":
        return (
          <div className="w-full mx-auto">
            <InputComponent
              type={"number"}
              value={value || ""}
              onChange={onChange}
              onKeyDown={onChange}
              label={!isTable && field.label}
              placeholder={field.placeholder}
              helperText={!isTable && "Please Enter the Value"}
              error={fieldError}
              id={field.id}
              name={field.id}
              className="custom-input-class"
              mandatory={field.isCompulsory}
              height={"30px"}
            />
          </div>
        );
      case "number":
        return (
          <div className="w-full mx-auto">
            <InputComponent
              type={field.type}
              value={value || ""}
              onChange={onChange}
              onKeyDown={onChange}
              label={!isTable && field.label}
              placeholder={field.placeholder}
              helperText={!isTable && "Please Enter the Value"}
              error={fieldError}
              id={field.id}
              name={field.id}
              className="custom-input-class"
              mandatory={field.isCompulsory}
              height={"30px"}
            />
          </div>
        );
      // case "textarea":
      //   return (
      //     <div className={`w-full`}>
      //       <label className="block text-sm font-medium mb-1" htmlFor={field.id}>
      //         {field.label}
      //       </label>
      //       <textarea
      //         id={field.id}
      //         name={field.name}
      //         className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
      //         placeholder={field.placeholder}
      //       ></textarea>
      //     </div>
      //   );

      case "file":
        return (
          <FileAttachment
            onChange={(files) =>
              onChange({
                target: {
                  name: field.id,
                  value: files,
                },
              })
            }
            maxSize={10}
            label="Upload your document"
            id={field.id}
            name={field.id}
            value={value || []}
            error={fieldError}
            mandatory={field.isCompulsory}
          />
          //   <div className={`w-full`}>
          //     <label className="block text-sm font-medium mb-1" htmlFor={field.id}>
          //       {field.label}
          //     </label>
          //     <input
          //       id={field.id}
          //       name={field.name}
          //       type="file"
          //       className="w-full border rounded px-3 py-2 focus:outline-none focus:ring focus:border-blue-500"
          //     />
          //   </div>
        );
      case "textarea":
        return (
          <div className="w-full mx-auto">
            <MemoArea
              type={field.type}
              value={value || ""}
              onChange={onChange}
              label={field.label}
              placeholder={field.placeholder}
              helperText="Please Enter the Value"
              error={fieldError}
              id={field.id}
              name={field.id}
              mandatory={field.isCompulsory}
              // className="custom-input-class"
            />
          </div>
        );
      case "serial":
        return index;
      case "action_delete":
        return (
          <button
            onClick={(e) => {
              e.stopPropagation();
              deleteRow(index);
            }}
            className="flex justify-center items-center h-full w-full min-w-[22px]"
          >
            <DeleteIcon color={"red"} size={22} />
          </button>
        );
      default:
        return null;
    }
  };
  return <div>{renderField(field, onChange, value, fieldError)}</div>;
};

export default CustomFields;
